import { render } from "./BottomRive.vue?vue&type=template&id=62bfc85f&scoped=true"
import script from "./BottomRive.vue?vue&type=script&lang=js"
export * from "./BottomRive.vue?vue&type=script&lang=js"

import "./BottomRive.vue?vue&type=style&index=0&id=62bfc85f&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bfc85f"]])

export default __exports__